export class InitializationError extends Error {}
